import React from 'react'
import PropTypes from 'prop-types'
import { useHistory, useParams } from 'react-router-dom'
import { ReactComponent as CongratulationPayroll } from 'assets/figma-icons/CongratulationPayroll-overview.svg'
import { Text, Button, Spacer, Flex } from '@jisr-hr/design-system'
import I18n from 'translations/i18n'

const PayrollCongratCard = ({ style, last_payrun: { payrun, permissions } }) => {
  const history = useHistory()
  const { id } = useParams()

  return (
    <div
      className="payroll--congratulation-card"
      style={style}
    >
      <Spacer height={25} />
      <CongratulationPayroll />
      <Spacer height={16} />
      <Text
        typography="title"
        style={{ marginBottom: 12 }}
      >
        {I18n.t('congratulations')}
      </Text>
      <Text
        bold
        color="var(--color-natural-gray-darker-1)"
        typography="caption12"
        style={{ marginBottom: 12 }}
      >
        {I18n.t('payroll_has_successfully_been_confirmed', {
          date: payrun && payrun.date,
        })}
      </Text>
      <Spacer height={30} />
      {permissions && permissions.is_authorized && (
        <Flex justifyCenter>
          <Button
            label={I18n.t('start_processing_payments')}
            variant="secondary"
            size="medium"
            className="overview--payroll-card_btn"
            style={{ justifyContent: 'center' }}
            onClick={() =>
              history.push({
                pathname: '/payment_processing',
                state: { payrun_id: id },
              })
            }
          />
        </Flex>
      )}
    </div>
  )
}

PayrollCongratCard.propTypes = {
  style: PropTypes.shape(),
  last_payrun: PropTypes.shape(),
}

export default PayrollCongratCard
